export default __webpack_public_path__ + "static/media/review.8e3c86af.svg";